
import { DEFAULT_IMAGE } from "@/lib/config/cdn";

interface PropertyMainImageProps {
  image: string;
  title: string;
  index: number;
}

const PropertyMainImage = ({ image, title, index }: PropertyMainImageProps) => {
  return (
    <div className="w-full h-full flex items-center justify-center p-4">
      <img
        src={image}
        alt={`${title} - Image ${index + 1}`}
        className="max-h-full max-w-full object-contain"
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.onerror = null;
          target.src = DEFAULT_IMAGE;
        }}
      />
    </div>
  );
};

export default PropertyMainImage;
